import React, { useState } from 'react';
import { useTranslation } from '../i18n';

const PasswordInput = ({ labelName, id, onChangeFunction, value }) => {
  const [inputType, setInputType] = useState('password');

  const toggleInputType = () => {
    setInputType(inputType === 'password' ? 'text' : 'password');
  };

  const { t } = useTranslation();

  return (
    <div className="form-floating padding-right">
      <input
        type={inputType}
        className="form-control"
        id={id}
        placeholder={labelName}
        value={value}
        onChange={onChangeFunction}
        autoComplete="on"
        required
      />
      <label htmlFor={id}>{labelName}</label>
      <div
        className="show-password-btn fs-s pt-65"
        role="button"
        onClick={toggleInputType}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            toggleInputType();
          }
        }}
        tabIndex={0}
      >
        {inputType === 'password' ? t.show : t.hide}
      </div>
    </div>
  );
};

export default PasswordInput;
